var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1em",
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.571 0a1.714 1.714 0 011.612 2.306c3.488.694 6.103 3.617 6.103 7.123H.857C.857 5.923 3.471 3 6.96 2.306A1.714 1.714 0 018.571 0zm8.572 12H0v-1.714h17.143V12zM8.57 3.857c-2.665 0-4.928 1.62-5.708 3.857H14.28c-.78-2.237-3.043-3.857-5.709-3.857z",
    fill: "currentColor"
  })));
}

export default SvgService;